// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KxgF","option":"styles_option__hFTlE","selected":"styles_selected__14dnc"};